import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6B7FCAFD-C14A-49FC-A959-A2B6C7C2C5BC
 * name pause-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause-box.svg
 * tags
 * - Audio 
 * - Music 
 */
export const PauseBoxIcon = createSvgIcon(<><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.1 3 19 3M11 16H9V8H11V16M15 16H13V8H15V16Z" /></>, 'PauseBoxIcon');
export default PauseBoxIcon